export default __webpack_public_path__ + "static/bg-mesquita-0dd871c9577c0dd72e2d233e8546023a.png";